module.exports = __webpack_public_path__ + "img/verified.ec56bf2e.svg";